import $http from '../../../../axios-instance';

export async function getSgaCompleto({ commit, state, rootState }) {

    
    
    var idioma = rootState.productos_et.selectedProductEt.idioma;
    // TODO: cambiar version cuando sea dinamico
    var version = 6;
    var producto = rootState.productos_et.selectedProductEt.id;
    var empresa = rootState.productos_et.selectedProductEt.id_empresa;
    // productos_et_sga/sga/completo/{id}/{idioma}/{version}

    await $http.get(`productos_et_sga/sga/completo/${producto}/${idioma}/${empresa}/${version}`)
    .then((response) => {
        commit('setSgaCompleto', response.data)
    })
    .catch((error) => {
        
    })
}

export async function getClasificacionSGAListas({ commit, state}) {
    await $http.get('controles/20')
        .then((response) => {
            commit('setClasificacionSGAListas', response.data);
        })
        .catch((error) => {

        })
}

